import { ApiError, env, fetchWithAuth } from '@botto/core';

export interface CdpProjectOption {
  id: string;
  name: string;
}

/**
 * Active CDP projects for SMS channel `project_id` picker.
 * Uses the `cdp` audience access JWT (`Authorization: Bearer`).
 */
export async function fetchCdpProjects(): Promise<CdpProjectOption[]> {
  if (!env.cdpApiUrl) {
    throw new Error(
      'CDP API не настроен: задайте VITE_PROXY_CDP_TARGET (dev) или VITE_CDP_API_URL',
    );
  }

  const base = env.cdpApiUrl.replace(/\/$/, '');
  const res = await fetchWithAuth(`${base}/projects?status=active`, { method: 'GET' }, 'cdp');

  if (!res.ok) {
    let body: unknown = null;
    try {
      body = await res.json();
    } catch {
      body = await res.text();
    }
    throw new ApiError(`HTTP ${res.status} ${res.statusText}`, res.status, body);
  }

  const data = (await res.json()) as { items?: { id: string; name: string }[] };
  return (data.items ?? []).map((p) => ({ id: p.id, name: p.name }));
}
